export default __webpack_public_path__ + "static/Lazarus_Chowder-dd5e1595739b104b74e0cb6eee121b64.png";